import { Component, signal, Signal, WritableSignal, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { ButtonComponent } from '@libs/common/components';
import { AuthService } from '@libs/shared/auth';
import { CustomerModel } from '@libs/account/models';
import { FlashMessageModule } from '@libs/shared/common';

@Component({
  selector: 'ui-customer-change',
  templateUrl: './customer-change.component.html',
  styleUrls: ['./customer-change.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatRadioGroup,
    MatRadioButton,
    ButtonComponent,
    FlashMessageModule,
    MatDialogModule,
  ],
})
export class CustomerChangeComponent {
  public customers: Signal<CustomerModel[] | undefined> = this.authService.allCustomers;
  public current: Signal<CustomerModel | undefined> = this.authService.currentCustomer;
  public checked: WritableSignal<CustomerModel | undefined> = signal(undefined);

  public constructor(
    private readonly authService: AuthService,
    public dialogRef: MatDialogRef<CustomerChangeComponent>,
  ) {
  }

  public customerChecked(customer: CustomerModel): void {
    this.checked.set(customer);
  }

  public closeDialog(customer?: CustomerModel): void {
    this.dialogRef.close(customer);
  }
}
